import requestMajestic from "@/utils/requestToMajesticServer";

function getUrlParameter(name, location) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function saveEvent(context, name) {
  const video_id = context.rootState.brandChannel.tape.videobot_id;
  const session_id = window.__ovmSID;

  if (typeof session_id === "undefined") {
    return false;
    // throw new Error("No SessionID error"); // pq não funciona?!??!
  }

  const event = {
    key: name,
    created_at: new Date().toISOString(),
  };

  const user_id = context.rootState.brandChannel.tape.ovm_config.env.user_id;
  if (user_id !== "undefined") {
    event.client_viewer_id = user_id;
  }

  if (navigator && navigator.userAgent) {
    event.user_agent = navigator.userAgent;
  }

  const uuid = getUrlParameter("id", context.rootState.brandChannel.tape.path);

  return requestMajestic({
    url: `/session/${session_id}/events`,
    method: "post",
    data: { event },
    headers: {
      uuid: uuid, // Adiciona o UUID como valor do header 'X-Request-Id'
    },
  });
}
